import Component from '../core/Component'
import Scroll from '../services/Scroll'
import debounce from 'lodash/debounce'

export default class Footer extends Component {
    constructor(element, options = {}) {
        super(element, options)
    
        this.ref = {
            titles: []
        }

        this.resizeEnd = debounce(this.resizeEnd, 200)
        this.isResized = false
    }

    prepare() {
        this.resize()
        Scroll.on('resize-x', this.handleResize)
    }
    
    destroy() {
        Scroll.off('resize-x', this.handleResize)
    }

    handleResize = () => {
        this.clear()
        this.resizeEnd()
    }
    
    resizeEnd() {
        this.resize()
    }

    resize() {
        const heights = this.ref.titles.map(titleEl => titleEl.getBoundingClientRect().height)
        const maxHeight = Math.max(...heights)
        this.ref.titles.forEach((titleEl, index) => {
            const height = heights[index]
            if (height === maxHeight) {
                return
            }
            titleEl.style.height = `${maxHeight}px`
            
            let html = titleEl.innerHTML
            const lastIndex = html.lastIndexOf(" ")
            titleEl.innerHTML = html.substr(0, lastIndex) + '<br class="auto">' + html.substr(lastIndex + 1)
        })
        this.isResized = true
    }

    clear() {
        if (!this.isResized) {
            return
        }
        this.ref.titles.forEach(titleEl => {
            let html = titleEl.innerHTML

            titleEl.style.height = ''
            titleEl.innerHTML = html.replace('<br class="auto">',' ')
        })
        this.isResized = false
    }
}